import React from "react";
import StdLibrary from "../../components/StudentTabs/StudentLibrary/StdLibrary"

const LibraryDetails= () => {
  return (
    <div>
      
      <StdLibrary/>
    </div>
  );
};

export default LibraryDetails;